import { AvailableCredits } from "@/components/pieces/coaching/available-credits/AvailableCredits";
import { CoachingCustomer } from "@/types/users";

interface BalancesProps {
  user: CoachingCustomer;
  viewAsCoach: boolean;
}

export function Balances({ user, viewAsCoach }: BalancesProps) {
  return (
    <AvailableCredits
      user={user}
      className="flex-grow"
      title={viewAsCoach ? "AVAILABLE TO CLIENT" : "AVAILABLE TO COACH"}
      secondaryLabel={viewAsCoach ? "" : "Buy Credits"}
      secondaryLink={viewAsCoach ? "" : "/buy"}
    />
  );
}
